import { Page, Content, InfoCard, Link } from '@backstage/core-components';
import { VariaPageHeader } from '@internal/frontend-common';
import { makeStyles } from '@material-ui/core/styles';
import { DevDocs } from './DevDocs';
import { FeatureNavigationTiles } from './FeatureNavigationTiles';
import { NewsWidget, NEWS_WIDGET_TITLE } from './NewsWidget';
import { CalendarEventsWidget } from '@internal/backstage-plugin-community-calendar';
import { Grid } from '@backstage/ui';
import { DOCS_BASE_URL } from './devDocLinks';

const useStyles = makeStyles({
  widgetLink: {
    fontSize: '1rem',
    marginRight: '16px',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
});

export const HOME_PAGE_TITLE = 'Varia - Making life easier for developers';

export const HomePage = () => {
  const classes = useStyles();

  return (
    <Page themeId="home">
      <VariaPageHeader title={HOME_PAGE_TITLE} />
      <Content>
        <FeatureNavigationTiles />

        {/* Two-column layout: Left column stacks Calendar + Videos, Right column has Dev Docs */}
        <Grid.Root columns={{ sm: '1', md: '2' }}>
          <Grid.Item
            colSpan="1"
            style={{ maxWidth: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            <InfoCard
              title="Upcoming community events"
              action={
                <Link to="/community-calendar" className={classes.widgetLink}>
                  See all events
                </Link>
              }
            >
              <CalendarEventsWidget />
            </InfoCard>
            {NEWS_WIDGET_TITLE && (
              <InfoCard title={NEWS_WIDGET_TITLE}>
                <NewsWidget />
              </InfoCard>
            )}
          </Grid.Item>

          <Grid.Item colSpan="1">
            <InfoCard
              title="Equinor Developer"
              action={
                <Link to={DOCS_BASE_URL} className={classes.widgetLink}>
                  See full documentation
                </Link>
              }
            >
              <DevDocs />
            </InfoCard>
          </Grid.Item>
        </Grid.Root>
      </Content>
    </Page>
  );
};
